/**
 * @module beebee-base/lib/utility/relationships
 * @description Relationship (added/removed related) helpers.
 */

/**
 * Aggiunge una relazione a un record parent
 * @param {Object} parent - Record parent
 * @param {Object} item - Item da aggiungere
 * @returns {Object} Parent modificato
 */
function addRelationship(parent, item) {
  if (!parent || !item) return parent;
  const addedRelated = parent.addedRelated || [];
  const removedRelated = parent.removedRelated || [];
  if (!addedRelated.includes(item)) {
    addedRelated.push(item);
    parent.set('addedRelated', addedRelated);
  }
  const removedIdx = removedRelated.indexOf(item);
  if (removedIdx !== -1) {
    removedRelated.splice(removedIdx, 1);
    parent.set('removedRelated', removedRelated);
  }
  return parent;
}

/**
 * Rimuove una relazione da un record parent
 * @param {Object} parent - Record parent
 * @param {Object} item - Item da rimuovere
 * @returns {Object} Parent modificato
 */
function delRelationship(parent, item) {
  if (!parent || !item) return parent;
  const addedRelated = parent.addedRelated || [];
  const removedRelated = parent.removedRelated || [];
  if (!removedRelated.includes(item)) {
    removedRelated.push(item);
    parent.set('removedRelated', removedRelated);
  }
  const addedIdx = addedRelated.indexOf(item);
  if (addedIdx !== -1) {
    addedRelated.splice(addedIdx, 1);
    parent.set('addedRelated', addedRelated);
  }
  return parent;
}

export { addRelationship, delRelationship };
//# sourceMappingURL=relationships.js.map
